import React, { Component } from 'react';
import { Button, Chip, CircularProgress } from '@mui/material';
import { connect } from 'react-redux';

import { listOnboardings } from '../../actions/onboarding';
import Table from '../../components/Table';
import { dateFormat } from '../../lib/utils';
import OnboardingStatus from './onboardingStatus';

class OnboardingList extends Component {
  constructor() {
    super();
    this.state = {
      selectedOnboardingId: null
    };
    this.listReq = false;
  }

  componentDidMount() {
    this.listReq = true;
    this.props.listOnboardings(100, 0);
  }

  componentWillReceiveProps(nextProps) {
    if (this.listReq && nextProps.onboardingList) {
      this.listReq = false;
    }
  }

  refreshList = () => {
    this.listReq = true;
    this.props.listOnboardings(100, 0);
  }

  openStatus = (onboardingId) => {
    this.setState({ selectedOnboardingId: onboardingId });
  }

  closeStatus = () => {
    this.setState({ selectedOnboardingId: null });
    this.refreshList();
  }

  render() {
    const { onboardingList, onClose } = this.props;
    const { selectedOnboardingId } = this.state;

    const list = onboardingList?.onboardings || onboardingList?.data?.onboardings || [];

    return (
      <div>
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 16 }}>
          <p style={{ fontSize: 18, fontWeight: 500, margin: 0 }}>Onboarding History</p>
          <div style={{ display: 'flex', gap: 8 }}>
            <Button onClick={this.refreshList} variant="outlined" size="small">Refresh</Button>
            <Button onClick={onClose} size="small">Back</Button>
          </div>
        </div>

        {!onboardingList ? (
          <div style={{ textAlign: 'center', padding: 40 }}><CircularProgress /></div>
        ) : (
          <Table
            column={[
              { name: 'Tenant Name', value: 'tenantName' },
              { name: 'Email', value: 'contactEmail' },
              { name: 'Type', value: 'tenantType', cell: val => (
                <Chip label={val} size="small" variant="outlined" />
              )},
              { name: 'Status', value: 'overallStatus', cell: val => (
                <Chip
                  label={val}
                  size="small"
                  color={val === 'completed' ? 'success' : val === 'failed' ? 'error' : 'warning'}
                />
              )},
              { name: 'Source', value: 'source' },
              { name: 'Created', value: 'createdAt', style: { width: 120 }, cell: val => {
                if (!val) return '--';
                const d = new Date(val);
                return isNaN(d.getTime()) ? '--' : dateFormat(d);
              }},
              { name: 'Actions', value: 'onboardingId', cell: (val) => (
                <Button size="small" onClick={() => this.openStatus(val)}>View</Button>
              )},
            ]}
            serialNumber
            data={list}
            showPagination
            pageOptions={[50, 100]}
            defaultPageSize={50}
          />
        )}

        {selectedOnboardingId && (
          <OnboardingStatus
            onboardingId={selectedOnboardingId}
            onClose={this.closeStatus}
          />
        )}
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    onboardingList: state.onboarding.onboardingList,
  };
}

export default connect(mapStateToProps, { listOnboardings })(OnboardingList);
